import { render, staticRenderFns } from "./dashboard_items_list.vue.js?vue&type=template&id=2cdf0f0b&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard_items_list.vue?vue&type=template&id=2cdf0f0b&vue3"
import script from "./dashboard_items_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard_items_list.vue?vue&type=script&lang=js&vue3"
export * from "./dashboard_items_list.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dashboard_items_list.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports